/// <reference path="../../Common/Base/SiteEntityDialog.ts" />

namespace Matrix.Data {

    @Serenity.Decorators.registerClass()
    @Serenity.Decorators.responsive()
    @Serenity.Decorators.panel()
    export class CurrencyDialog extends SiteEntityDialog<CurrencyRow, any> {
        protected getFormKey() { return CurrencyForm.formKey; }
        protected getIdProperty() { return CurrencyRow.idProperty; }
        protected getLocalTextPrefix() { return CurrencyRow.localTextPrefix; }
        protected getNameProperty() { return CurrencyRow.nameProperty; }
        protected getService() { return CurrencyService.baseUrl; }

        protected form = new CurrencyForm(this.idPrefix);

    }
}